//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const EmployeeFundsSubledgerRecConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path     : '/app/ewa/subledgerRec',
      component: FuseLoadable({
          loader: () => import('./Mainworkflow')
      })
  }
  ]
  //end routes
};
